var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48421 0.981172V8.62328C1.48421 8.92723 1.70132 9.14433 2.00526 9.14433H11.0368C11.3191 9.14433 11.5579 9.38315 11.5579 9.66538C11.5579 9.96933 11.3191 10.1864 11.0368 10.1864H2.00526C1.13684 10.1864 0.442105 9.4917 0.442105 8.62328V0.981172C0.442105 0.698935 0.65921 0.46012 0.963157 0.46012C1.24539 0.46012 1.48421 0.698935 1.48421 0.981172ZM10.7112 3.43446L7.73684 6.38709C7.54145 6.6042 7.21579 6.6042 7.02039 6.38709L5.30526 4.67196L3.59013 6.38709C3.37303 6.6042 3.04737 6.6042 2.85197 6.38709C2.63487 6.1917 2.63487 5.86604 2.85197 5.67065L4.93618 3.58644C5.02303 3.47788 5.15329 3.43446 5.30526 3.43446C5.43553 3.43446 5.56579 3.47788 5.67434 3.58644L7.38947 5.30157L9.97303 2.71801C10.1684 2.50091 10.4941 2.50091 10.7112 2.71801C10.9066 2.91341 10.9066 3.23907 10.7112 3.43446Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsIcon2);
export default __webpack_public_path__ + "static/media/resultsIcon2.2d309824359cc8c0e5478bd1941230eb.svg";
export { ForwardRef as ReactComponent };